<p>Please enter your password to access respondents:</p>
<input matInput type="password" [(ngModel)]="password" />

<div mat-dialog-actions class="flex-spaced">
  <button mat-flat-button class="back" [mat-dialog-close]="false">Back</button>
  <button mat-flat-button class="accept" (click)="verifyPassword()">Accept</button>
</div>
